import ButtonComponent from './ButtonComponent';
import withStyles from '@material-ui/core/styles/withStyles';

const BtnSecHoverComponent = withStyles((theme) => ({
    root: {
        '&:hover': {
            background: theme.palette.secondary.main,
        }
    },
}))(ButtonComponent);

export default BtnSecHoverComponent;